// This file is part of InvenioRDM
// Copyright (C) 2023 CERN.
//
// Invenio App RDM is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

/**
 * Add here all the overridden components of your app.
 */

import PublishModal from "../../invenio_rdm_records/src/deposit/controls/PublishButton";
import SubmitReviewModal from "../../invenio_rdm_records/src/deposit/controls/PublishButton";
import TimelineCommentEvent from "../../invenio_requests/timelineEvents/TimelineCommentEvent";

const customUploadLicenseComponent = () => null;
const customUploadContributorsComponent = () => null;
const customUploadLanguagesComponent = () => null;
const customDateComponent = () => null;
const customVersionComponent = () => null;
const customPublisherComponent = () => null;
const customFundingComponent = () => null;
const customAlternateIdsComponent = () => null;
const customRelatedWorkComponent = () => null;
const customReferencesComponent = () => null;

const customAccessRightFieldComponent = () => null;

const customCommunitySelectionButton = () => null;
const customRemoveCommunityButton = () => null;

export const overriddenComponents = {

  "InvenioAppRdm.Deposit.LicenseField.container": customUploadLicenseComponent,
  "InvenioAppRdm.Deposit.ContributorsField.container": customUploadContributorsComponent,
  "InvenioAppRdm.Deposit.LanguagesField.container": customUploadLanguagesComponent,
  "InvenioAppRdm.Deposit.DateField.container": customDateComponent,
  "InvenioAppRdm.Deposit.VersionField.container": customVersionComponent,
  "InvenioAppRdm.Deposit.PublisherField.container": customPublisherComponent,
  "InvenioAppRdm.Deposit.AccordionFieldFunding.container": customFundingComponent,
  "InvenioAppRdm.Deposit.AccordionFieldAlternateIdentifiers.container": customAlternateIdsComponent,
  "InvenioAppRdm.Deposit.AccordionFieldRelatedWorks.container": customRelatedWorkComponent,
  "InvenioAppRdm.Deposit.AccordionFieldReferences.container": customReferencesComponent,
  "InvenioAppRdm.Deposit.AccessRightField.container": customAccessRightFieldComponent,

  "InvenioRdmRecords.CommunityHeader.CommunitySelectionButton.Container": customCommunitySelectionButton,
  "InvenioRdmRecords.CommunityHeader.RemoveCommunityButton.Container": customRemoveCommunityButton,

  "InvenioRdmRecords.PublishModal.container": PublishModal,
  "InvenioRdmRecords.SubmitReviewModal.container": SubmitReviewModal,
  "InvenioRequests.TimelineEvent.layout.comment": TimelineCommentEvent,
};
